import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { cashdeskPageModel } from '../../model';
import { CashdeskPageHeading } from '../cashdesk-page-heading';
import { CashdeskPageTabs } from '../cashdesk-page-tabs';
import cls from './cashdesk-page.module.scss';

export const CashdeskPage = () => {
	const [loading, currentTab] = useUnit([
		cashdeskPageModel.$pending,
		cashdeskPageModel.currentTabState.$value,
	]);

	return (
		<AppShell.Main
			className={cls.cashdeskPage}
			data-tab={currentTab}
		>
			{loading ? (
				<Loader />
			) : (
				<>
					<CashdeskPageHeading />
					<CashdeskPageTabs />
				</>
			)}
		</AppShell.Main>
	);
};
